<ng-container>
  <ion-list lines="none" style="padding: 0 5px">
    @for (
      conversationGroup of linkedConversationGroupEntries();
      track conversationGroup[0]
    ) {
      <h4 class="linkedConversationGroupLabel">
        <ion-icon
          style="margin-right: 1px; font-size: 1.2rem"
          name="{{
            CONVERSATION_LINK_TYPES_UNIDIRECTIONAL_ICONS[conversationGroup[0]]
          }}"
        ></ion-icon>
        {{
          CONVERSATION_LINK_TYPES_UNIDIRECTIONAL_LABELS[conversationGroup[0]]
        }}:
      </h4>
      <app-conversation-list
        [unlinkingEnabled]="true"
        [disableAssignment]="true"
        [disableSelection]="true"
        [showSummary]="true"
        [whereClauses]="[
          {
            field: 'id',
            operator: 'in',
            value: getConversationIdsFromGroup(conversationGroup[1])
          }
        ]"
        [routerPath]="getRouterPath()"
        routerDirection="root"
        [showEmptyState]="true"
        [showTags]="false"
        (didUnlinkConversation)="
          unlinkConversation($event, conversationGroup[0])
        "
      ></app-conversation-list>
    }
  </ion-list>

  <ion-list class="no-padding" lines="none">
    <ion-item>
      <ion-button
        color="light"
        style="margin: 0 5px 0 0"
        [disabled]="disabled"
        (click)="showCreateOptions()"
      >
        <ion-icon name="add-circle" class="padded-icon"></ion-icon>
        Create new
      </ion-button>
      <ion-button
        color="light"
        class="no-margin"
        [disabled]="disabled"
        (click)="openLinkExistingModal()"
      >
        <ion-icon name="link-outline" class="padded-icon"></ion-icon>
        Link existing
      </ion-button>
      <ion-button
        fill="clear"
        color="dark"
        class="no-margin"
        (click)="refreshConversationListComponents()"
        [disabled]="isLoading || disabled"
      >
        <ion-spinner
          name="crescent"
          *ngIf="isLoading"
          style="width: 16px"
        ></ion-spinner>
        <ion-icon name="refresh-outline" *ngIf="!isLoading"></ion-icon>
      </ion-button>
    </ion-item>
  </ion-list>
</ng-container>

<ion-modal #linkExistingModal [cssClass]="'auto-height modal-sm'">
  <ng-template>
    <ion-header>
      <ion-toolbar>
        <ion-title>Link to Conversation</ion-title>
        <ion-buttons slot="end">
          <ion-button (click)="linkExistingModal.dismiss()">
            <ion-icon name="close-outline"></ion-icon>
          </ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <div style="padding: 0 12px">
      <ion-chip
        mode="ios"
        [outline]="true"
        class="select-chip select-outline"
        (click)="showLinkTypeOptions()"
        [disabled]="disabled"
      >
        <ion-label>
          <ion-icon
            class="padded-icon"
            name="{{ CONVERSATION_LINK_TYPES_UNIDIRECTIONAL_ICONS[linkType] }}"
          ></ion-icon>
          {{ CONVERSATION_LINK_TYPES_UNIDIRECTIONAL_LABELS[linkType] }}
          <ion-icon
            name="chevron-down-outline"
            class="icon-padded-left"
          ></ion-icon>
        </ion-label>
      </ion-chip>
      <ion-chip
        mode="ios"
        [outline]="true"
        class="select-chip select-outline"
        (click)="showLinkableConversations()"
        [disabled]="disabled"
      >
        <ion-label>
          {{
            linkedConversation
              ? formatConversationTitle(linkedConversation)
              : "Choose conversation..."
          }}
          <ion-icon
            name="chevron-down-outline"
            class="icon-padded-left"
          ></ion-icon>
        </ion-label>
      </ion-chip>
    </div>
    <div class="inner-content">
      <ion-footer class="footer ion-no-border">
        <ion-button (click)="submit()" [disabled]="isSubmitting">
          Confirm
          <ion-spinner
            name="crescent"
            [hidden]="!isSubmitting"
            style="margin-left: 10px"
          ></ion-spinner>
        </ion-button>
      </ion-footer>
    </div>
  </ng-template>
</ion-modal>
